import { useMemo } from 'react';

import { Option } from '@/components/inputs/AutocompleteInput';

interface UseAutocompleteProps<T> {
  data: T[];
  getLabel: (item: T) => string;
}

const useAutocomplete = <T>({ data, getLabel }: UseAutocompleteProps<T>) => {
  const options = useMemo<Option[]>(() => {
    return data.map((item: any) => ({
      label: getLabel(item),
      data: item,
    }));
  }, [data, getLabel]);

  return { options };
};

export default useAutocomplete;
